module.exports = __webpack_public_path__ + "static/media/delete.e13cb921.svg";